export const colors: {[name: string]: string} = {
  codGrey: '#1A1A1A',
  black: '#000000',
  background: '#272726',
  fadedText: 'rgba(0, 0, 0, 0.56)',
  moreFadedText: 'rgb(0, 0, 0, 0.4)',
  mediumGrey: '#555',
  lightGrey: '#aaa',
  primary: '#F25757',
  concrete: '#F5F0EB',
  alto: '#E0E0E0',
  carnation: '#F25757',
  treePoppy: '#FA9917',
  conifer: '#B0D344',
  deYork: '#72c07a',
  saffron: '#F3CA3E',
  cornflowerBlue: '#6195ED',
  mosque: '#016678',
  pickledBluewood: '#2F4858',
  offYellow: '#dec68c',
  charmPink: '#e3879e',
  frenchMauve: '#d183c9',
  brickRed: '#fb4824',
  white: '#fff',
  slate: '#4a3943',
  jaffa: '#F18E32',
  goldDrop: '#E08700',
  tulipTree: '#efb639',
  jungleGreen: '#21a464',
  pink: '#e59bb3',
  blush: '#e5a79b',
  fadedGreen: 'rgba(3, 128, 0, 0.6)',
  fadedBrown: 'rgba(189, 79, 0, 0.6)',
  fadedBlue: 'rgba(0,78,103, 0.6)',
  fadedPink: 'rgba(153,51,102, 0.6)',
  fadedPurple: 'rgba(107, 85, 145, 0.6)',
  fadedMaroon: 'rgba(81, 52, 77, 0.6)',
  fadedRed: 'rgba(188,0,0, 0.6)',
  fadedGrey: 'rgba(0, 0, 0, 0.03)',
  lightBeige: 'rgba(245, 240, 235, 0.4)',
  red: '#FF0000',
  brick: '#FB4824',
  terracotta: '#CE5B36',
  periwinkleGray: '#B8C6E3',
  bone: '#f3f3f3',
  frostee: '#ebf8eb',
  fairPink: '#ffe8e8',
  hintOfRed: '#F5F2F2',
  pastelPink: '#ff66a3',
  pastelYellow: '#f0e68c',
  pastelGreen: '#90ee90',
  pastelBlue: '#87cefa',
  pastelPurple: '#d8bfd8',
  noteYellow: '#feedaf',
  darkNoteYellow: '#fece00',
  springWood: '#F5F0EB',
  springWoodLight: '#FBF9F7',
  fadedBrick: 'rgba(251, 72, 36, 0.6)',
  darkenedBrick: '#E12904',
  pizazz: '#FF8C00',
  internationalKleinBlue: '#0033b6',
  twitterBlue: '#1DA1F2',
  saltpan: '#EAF3E9',
  caribbeanGreen: '#00C08C',
  japaneseLaurel: '#038000',
  muddyWaters: '#B8846B',
  selectiveYellow: '#FBBC04',
  buttonBlue: '#15659f',
  violet: '#8b5cf6',
  lightViolet: '#a78bfa',
  pelorous: '#3fb6c6',
  heatmapBlue1: '#dce9f4',
  heatmapBlue2: '#a9c8e3',
  heatmapBlue3: '#6fa2cf',
  heatmapBlue4: '#3a7cb6',
  heatmapNavy1: '#1b2a3d',
  heatmapNavy2: '#21406a',
  heatmapNavy3: '#2c5c99',
  heatmapNavy4: '#4278c9',
  rankBlue1: '#0B3B5E',
  rankBlue2: '#14659F',
  rankBlue3: '#4A8CC2',
  rankBlue4: '#9CC0DE',
  rankGreen1: '#0A5E43',
  rankGreen2: '#0B8A5E',
  rankGreen3: '#3FB488',
  rankGreen4: '#9ED9C0',
  rankPlum1: '#43183A',
  rankPlum2: '#5E274A',
  rankPlum3: '#8E5A7C',
  rankPlum4: '#C9A6BD',
  rankTeal1: '#0E4F55',
  rankTeal2: '#16737A',
  rankTeal3: '#4FA3A8',
  rankTeal4: '#A3D2D4',
  rankOrange1: '#7A2E0B',
  rankOrange2: '#B4501A',
  rankOrange3: '#DC7B3E',
  rankOrange4: '#F2B48A',
  rankGold1: '#5C4300',
  rankGold2: '#8A6500',
  rankGold3: '#BF9420',
  rankGold4: '#E8D08A',
  rankIndigo1: '#1F2766',
  rankIndigo2: '#34449A',
  rankIndigo3: '#6575C4',
  rankIndigo4: '#B1BAE5',
  rankMagenta1: '#64103C',
  rankMagenta2: '#9A215B',
  rankMagenta3: '#CC5690',
  rankMagenta4: '#ECB0CC',
  seriesBrown: '#8B5E34',
  seriesBrownDark: '#C69C6D',
  rankContext: '#BDBDBD',
  rankUnranked: '#E6E6E6',
  rankReference: '#1C1B1F',
  rankMeta: '#828689',
  rankMetaDark: '#A3A6A9',
  rankScale1: '#3A3A3A',
  rankScale2: '#6B6B6B',
  rankScale3: '#9E9E9E',
  rankScale4: '#D0D0D0',
};

const gray = {
  'gray.50': '#fafafa',
  'gray.100': '#f5f5f5',
  'gray.200': '#eeeeee',
  'gray.300': '#e0e0e0',
  'gray.400': '#bdbdbd',
  'gray.500': '#9e9e9e',
  'gray.600': '#757575',
  'gray.700': '#616161',
  'gray.800': '#424242',
  'gray.900': '#212121',
};

Object.assign(colors, gray);

export const AVATARCOLORS = [
  colors.pastelPink,
  colors.pastelYellow,
  colors.pastelGreen,
  colors.pastelBlue,
  colors.pastelPurple,
];

export const fileTypeColors = {
  image: '#10b981',
  video: '#3b82f6',
  pdf: '#ef4444',
  doc: '#3086F6',
  xls: '#34A853',
  generic: '#6b7280',
};
